export const SET_ERROR = "SET_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";